import { colorAttributeCompare } from "@features/pdp/attribute-sorting";
import { MIYO_DISABLED_COLORS } from '@features/pdp/settings';
import { Views } from '@types';
import { formatCurrency } from '@utils/formatters.util';
import classNames from 'classnames';
import React, { memo } from 'react';
import { FiChevronRight } from 'react-icons/fi';
import { Button } from '../../../../components/tailwind';

type Props = {
  onUpdateClick: () => void;
  bundleInfo: any;
  view: Views;
  quantity: number;
  choice: any;
};

const ActiveVariant = ({ onUpdateClick, choice, bundleInfo, view, quantity }: Props) => {
  const colorChoices = bundleInfo.bundle.memberChoiceItemIds[bundleInfo.customInfo.customizing].map(
    (itemId) => {
      const item = bundleInfo.itemsById[itemId];
      const colorId = item.attributes.color;
      const color = bundleInfo.attributesByKey.color[colorId];
      return Object.assign({}, color, {
        item,
        isInStock: item?.inStockNow,
        isAvailable: true,
      });
    }
  );

  const colors =
    colorChoices
      ?.filter(
        (color) =>
          color.item.canMiyo &&
          !MIYO_DISABLED_COLORS.includes(color.id) &&
          color.isInStock &&
          color.isAvailable
      )
      .toSorted(colorAttributeCompare) ?? [];

  const bundleItem = bundleInfo.selectedItems[bundleInfo.customInfo.customizing];
  const activeColor = colors.find((c) => c.id === bundleItem.attributes.color);

  const changeItemHandler = (swatchData) => onUpdateClick;

  if ([Views.REVIEW, Views.REVIEW_UPDATE_PREVIEW].includes(view)) {
    return null;
  }

  const displayName = [choice?.displayName, activeColor?.value].filter((v) => !!v).join(', ');

  return (
    <>
      <div
        className={classNames('tw-flex tw-items-center tw-justify-between tw-gap-2 tw-overflow-hidden', {
          'tw-my-5 tw-cursor-pointer tw-rounded-xl hover:tw-bg-neutral-100 tw-border-x tw-border-y tw-border-neutrals-light-grey tw-p-4 [&_*]:tw-cursor-pointer tw-transition tw-duration-200':
            view === Views.DESIGN,
          'tw-my-4 tw-border-b tw-border-neutrals-light-grey tw-pb-4': [
            Views.REVIEW,
            Views.REVIEW_UPDATE_PREVIEW,
          ].includes(view),
        })}
        onClick={onUpdateClick}>
        <p
          className={classNames('tw-mb-0 tw-w-full tw-text-xs tw-font-bold tw-text-brand-black', {
            'tw-whitespace-nowrap': view === Views.DESIGN,
          })}>
          {displayName}
        </p>

        <div
          className={classNames('tw-flex tw-justify-end', {
            'tw-w-full': view === Views.DESIGN,
          })}>
          {[Views.REVIEW, Views.REVIEW_UPDATE_PREVIEW].includes(view) ? (
            <p className='tw-mb-0 tw-text-right tw-text-xs tw-font-bold tw-text-brand-black'>
              {formatCurrency(bundleItem?.rate * (quantity || 1))}
            </p>
          ) : (
            <Button type='button' variant='link' size='md' noPadding className='tw-pointer-events-none'>
              <div className='tw-inline-flex tw-items-center'>
                <span>Update</span>
                <FiChevronRight size={24} className='t-text-brand-black' />
              </div>
            </Button>
          )}
        </div>
      </div>
    </>
  );
};

export default memo(ActiveVariant);
